import type {
  GetMessagesQuery,
  GetMessagesQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_MESSAGES: TypedDocumentNode<
  GetMessagesQuery,
  GetMessagesQueryVariables
> = gql`
  query GetMessages($input: MessagesQueryInput) {
    messages(input: $input) {
      id
      value
      source
      sourceId
      createdAt
      updatedAt
      userId
      messageContexts {
        name
        value
      }
    }
  }
`;
